<template>
  <BaseListItem v-if="edit">
    <div class="flex items-baseline -mx-4">
      <div class="flex flex-1 px-2 space-x-2">
        <ValidationProvider
          name="number"
          :vid="`phones.${index}.number`"
          rules="required"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormInput
              v-model.lazy="number"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter phone number"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
        <ValidationProvider
          name="type"
          :vid="`phones.${index}.type`"
          rules="required"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormSelect
              v-model="type"
              :options="accountPhoneTypes"
              :disabled="updating"
              :invalid="failed"
              placeholder="enter phone number"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
      </div>
      <div class="pr-2">
        <BaseIconButton v-if="!updating" icon="trash" brand @click="$emit('destroy')" />
        <Loader v-else small />
      </div>
    </div>
  </BaseListItem>
  <BaseListItem v-else-if="updating">
    <div class="flex items-baseline -mx-4">
      <div class="flex-1 px-4 text-red-500 text-center">
        <Loader medium />
      </div>
    </div>
  </BaseListItem>
  <BaseListItem v-else>
    <div class="flex items-baseline -mx-4">
      <div class="flex-1 px-4 truncate">
        <p>{{ entity.number }}</p>
        <span class="capitalize text-gray-700 text-sm">
          {{ entity.type }}
        </span>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
export default {
  name: 'ListingItem',
  props: {
    index: {
      type: Number,
      required: true,
    },
    entity: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      default: 'trash',
    },
    edit: Boolean,
    updating: Boolean,
  },
  computed: {
    number: {
      get() {
        return this.entity.number;
      },
      set(number) {
        this.$emit('change', { ...this.entity, number });
      },
    },
    type: {
      get() {
        return this.entity.type;
      },
      set(type) {
        this.$emit('change', { ...this.entity, type });
      },
    },
    accountPhoneTypes() {
      return [
        {
          value: 'landline',
          label: 'Landline',
        },
        {
          value: 'mobile',
          label: 'Mobile',
        },
      ];
    },
  },
};
</script>
